module.exports = __webpack_public_path__ + "static/engine-world-tracking-for-web-e7a404c4f268137458074405ffa3e9a7.jpg";